import {
  lessonGuidesPage, manageUnitsPage, programPages, RailPage,
} from './contentPages';
import useProgramTree from './useProgramTree';

// The program pages' shared tab row: Table of Contents, Units, Lesson Guides (the first lesson's,
// as the legacy header tab did, once the lessons are known), then the rest with Edit Program last.
// Reads the tree's light lessons query, which the rail has usually fetched already.
const useProgramPageTabs = (programId: number): RailPage[] => {
  const { allLessons } = useProgramTree(programId);
  const firstLesson = allLessons[0];
  const [tableOfContents, ...otherPages] = programPages(programId);

  return [
    tableOfContents,
    { ...manageUnitsPage(programId), label: 'Units' },
    ...(firstLesson ? [lessonGuidesPage(firstLesson.id, programId)] : []),
    ...otherPages,
  ];
};

export default useProgramPageTabs;
